import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const AuthContext = createContext(null);
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || import.meta.env.REACT_APP_BACKEND_URL;

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('stopscam_admin_token') || '');
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (token) localStorage.setItem('stopscam_admin_token', token); else localStorage.removeItem('stopscam_admin_token'); }, [token]);

  async function refresh() {
    try {
      setLoading(true);
      // During transition, allow token mode for one cycle; otherwise prefer session-based
      const res = await fetch(`${BACKEND_URL}/api/auth/me`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        credentials: 'include'
      });
      if (res.ok) {
        const data = await res.json();
        setMe(data);
      } else {
        setMe({ role: 'anonymous' });
      }
    } catch (e) {
      setMe({ role: 'anonymous' });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { refresh(); }, [token]);

  const value = useMemo(() => ({ token, setToken, me, role: me?.role || 'anonymous', loading, refresh }), [token, me, loading]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}